export const encodeJSON = (input: unknown): string =>
  JSON.stringify(input, (_, value) =>
    typeof value === "bigint" ? { B_I_G_I_N_T: value.toString() } : value,
  )

export const convertToSnakeCase = (
  value: string,
  divider: RegExp | string = " ",
) => value.toLowerCase().split(divider).join("_")
